import Vue from "vue";
import VueRouter from "vue-router";
import MapView from "../views/MapView.vue";
import store from "@/store";
import constants from "@/utils/constants";
import { appIdentifier } from "@/utils/appIdentifier.js";

Vue.use(VueRouter);

const setMenuPageLanguage = (to, _from, next) => {
  if (to.query.lang?.match(/nl/g)) {
    store.commit("setLocale", "nl");
    next();
  } else if (to.query.lang?.match(/en/g)) {
    store.commit("setLocale", "en");
    next();
  } else {
    store.commit("setLocale", "en");
    next();
  }
};

function getMenuRoutes() {
  if (appIdentifier() == constants.HUYGENS) {
    return [
      {
        path: "/svs",
        name: "svs",
        beforeEnter: setMenuPageLanguage,
        meta: { mobile: true },
        component: () =>
          import(
            /* webpackChunkName: "huygens" */ "@/components/menus/pages/huygens/SVS.vue"
          )
      },
      {
        path: "/partners",
        name: "partners",
        beforeEnter: setMenuPageLanguage,
        meta: { mobile: true },
        component: () =>
          import(
            /* webpackChunkName: "huygens" */ "@/components/menus/pages/huygens/Partners.vue"
          )
      },
      {
        path: "/delfshaven",
        name: "huygens",
        beforeEnter: setMenuPageLanguage,
        meta: { mobile: true },
        component: () =>
          import(
            /* webpackChunkName: "huygens" */ "@/components/menus/pages/huygens/Huygens.vue"
          )
      },
      {
        path: "/colofon",
        name: "colofon",
        beforeEnter: setMenuPageLanguage,
        meta: { mobile: true },
        component: () =>
          import(
            /* webpackChunkName: "huygens" */ "@/components/menus/pages/huygens/Colofon.vue"
          )
      },
      {
        path: "/what-is-5d",
        name: "what-is-5d",
        beforeEnter: setMenuPageLanguage,
        meta: { mobile: true },
        component: () =>
          import(
            /* webpackChunkName: "huygens" */ "@/components/menus/pages/huygens/WhatIs5D.vue"
          )
      },
      {
        path: "/how-to-use",
        name: "how-to-use",
        beforeEnter: setMenuPageLanguage,
        meta: { mobile: true },
        component: () =>
          import(
            /* webpackChunkName: "huygens" */ "@/components/menus/pages/huygens/HowToUse.vue"
          )
      },
      {
        path: "/expert-mode",
        name: "expert-mode",
        beforeEnter: setMenuPageLanguage,
        meta: { mobile: true },
        component: () =>
          import(
            /* webpackChunkName: "huygens" */ "@/components/menus/pages/huygens/ExpertMode.vue"
          )
      }
    ];
  }

  if (appIdentifier() == constants.DORDRECHT5D) {
    return [
      {
        path: "/how-to-use",
        name: "how-to-use",
        beforeEnter: setMenuPageLanguage,
        meta: { mobile: true },
        component: () =>
          import(
            /* webpackChunkName: "dordrecht5d" */ "@/components/menus/pages/dordrecht5d/HowToUse.vue"
          )
      },
      {
        path: "/dordrecht5d",
        name: "dordrecht5d",
        beforeEnter: setMenuPageLanguage,
        meta: { mobile: true },
        component: () =>
          import(
            /* webpackChunkName: "dordrecht5d" */ "@/components/menus/pages/dordrecht5d/Dordrecht5d.vue"
          )
      },
      {
        path: "/what-is-5d",
        name: "what-is-5d",
        beforeEnter: setMenuPageLanguage,
        meta: { mobile: true },
        component: () =>
          import(
            /* webpackChunkName: "dordrecht5d" */ "@/components/menus/pages/dordrecht5d/WhatIs5D.vue"
          )
      },
      {
        path: "/expert-mode",
        name: "expert-mode",
        beforeEnter: setMenuPageLanguage,
        meta: { mobile: true },
        component: () =>
          import(
            /* webpackChunkName: "dordrecht5d" */ "@/components/menus/pages/dordrecht5d/ExpertMode.vue"
          )
      },
      {
        path: "/svs",
        name: "svs",
        beforeEnter: setMenuPageLanguage,
        meta: { mobile: true },
        component: () =>
          import(
            /* webpackChunkName: "dordrecht5d" */ "@/components/menus/pages/dordrecht5d/SVS.vue"
          )
      },
      {
        path: "/colofon",
        name: "colofon",
        beforeEnter: setMenuPageLanguage,
        meta: { mobile: true },
        component: () =>
          import(
            /* webpackChunkName: "dordrecht5d" */ "@/components/menus/pages/dordrecht5d/Colofon.vue"
          )
      }
    ];
  }

  if (appIdentifier() == constants.CANALS5D) {
    return [
      {
        path: "/svs",
        name: "svs",
        beforeEnter: setMenuPageLanguage,
        meta: { mobile: true },
        component: () =>
          import(
            /* webpackChunkName: "canals5d" */ "@/components/menus/pages/canals5d/SVS.vue"
          )
      },
      {
        path: "/partners",
        name: "partners",
        beforeEnter: setMenuPageLanguage,
        meta: { mobile: true },
        component: () =>
          import(
            /* webpackChunkName: "canals5d" */ "@/components/menus/pages/canals5d/Partners.vue"
          )
      },
      {
        path: "/canals5d",
        name: "canals5d",
        beforeEnter: setMenuPageLanguage,
        meta: { mobile: true },
        component: () =>
          import(
            /* webpackChunkName: "canals5d" */ "@/components/menus/pages/canals5d/Canals5d.vue"
          )
      },
      {
        path: "/colofon",
        name: "colofon",
        beforeEnter: setMenuPageLanguage,
        meta: { mobile: true },
        component: () =>
          import(
            /* webpackChunkName: "canals5d" */ "@/components/menus/pages/canals5d/Colofon.vue"
          )
      },
      {
        path: "/what-is-5d",
        name: "what-is-5d",
        beforeEnter: setMenuPageLanguage,
        meta: { mobile: true },
        component: () =>
          import(
            /* webpackChunkName: "canals5d" */ "@/components/menus/pages/canals5d/WhatIs5D.vue"
          )
      },
      {
        path: "/how-to-use",
        name: "how-to-use",
        beforeEnter: setMenuPageLanguage,
        meta: { mobile: true },
        component: () =>
          import(
            /* webpackChunkName: "canals5d" */ "@/components/menus/pages/canals5d/HowToUse.vue"
          )
      },
      {
        path: "/expert-mode",
        name: "expert-mode",
        beforeEnter: setMenuPageLanguage,
        meta: { mobile: true },
        component: () =>
          import(
            /* webpackChunkName: "canals5d" */ "@/components/menus/pages/canals5d/ExpertMode.vue"
          )
      },
      {
        path: "/streams",
        name: "currents",
        beforeEnter: setMenuPageLanguage,
        meta: { mobile: true },
        component: () =>
          import(
            /* webpackChunkName: "canals5d" */ "@/components/menus/pages/canals5d/Currents.vue"
          )
      }
    ];
  }
}

const routes = [
  //Map View
  {
    path: "/",
    name: "map-view",
    component: MapView,
    meta: {
      allowAppsModal: true
    }
  },

  //Share article
  {
    path: "/article/:id",
    name: "article-share",
    component: MapView,
    meta: {
      allowAppsModal: true
    },
    props: true
  },

  //Panorama View
  {
    path: "/hotspot/:id",
    name: "panorama-view",
    component: () =>
      import(
        /* webpackChunkName: "panoramaViewer" */ "../views/PanoramaViewer.vue"
      ),
    meta: {
      allowAppsModal: true
    }
  },

  //Menu pages,
  ...getMenuRoutes(),
  //404 handler
  {
    path: "*",
    component: MapView,
    props: { error404: true }
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
